import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { addToast, logout } from 'src/old/actions';
import { selectUserRole } from 'src/old/actions/session/sessionSelectors';
import { userRoles } from 'src/old/reducers/sessionReducer';
import { useLogoutMutation } from 'src/shared/api/auth';
import { toastTypes } from 'src/shared/components/Toast/ToastOptions';

type UseLogoutReturn = {
  logoutUser: () => Promise<void>;
  isLoggingOut: boolean;
};

const useLogout = (): UseLogoutReturn => {
  const dispatch = useDispatch();
  const history = useHistory();
  const role = useSelector(selectUserRole);
  const [requestLogout, { isLoading: isLoggingOut }] = useLogoutMutation();

  const logoutUser = async (): Promise<void> => {
    try {
      await requestLogout().unwrap();
      dispatch(logout());

      if (role === userRoles.ADMIN) {
        history.push('/super/holdings');
        return;
      }

      history.push('/auth/login');
    } catch (error) {
      dispatch(
        addToast(
          {
            ...toastTypes.error,
            defaultMessage: 'Could not complete logout. Please try again.'
          },
          error
        )
      );
    }
  };

  return {
    logoutUser,
    isLoggingOut
  };
};

export default useLogout;
